import { render } from "./MessengerList.vue?vue&type=template&id=a2bbac68"
import script from "./MessengerList.vue?vue&type=script&lang=js"
export * from "./MessengerList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__